import React, { Component } from 'react';
import TimeSlot from './TimeSlot';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { stat } from 'fs';
// import Chance from 'chance';
// import checkboxHOC from 'react-table/lib/hoc/selectTable';

// const CheckboxTable = checkboxHOC(ReactTable);

// const chance = new Chance();

function getData() {
    const data = [];
    let temp = 0, aHr = 0, aMin = 0;
    let aHrStr = "", aMinStr = "";
    for (var i = 0; i < 96; i++) {
        temp = i * 15;
        aHr = parseInt(temp / 60);
        aMin = temp - aHr * 60;
        if (aHr < 10) {
            aHrStr = "0" + aHr.toString();
        } else {
            aHrStr = aHr.toString();
        }
        if (aMin < 10) {
            aMinStr = "0" + aMin.toString();
        } else {
            aMinStr = aMin.toString();
        }
        // data.push(aHrStr + aMinStr);
        data.push({
            _id: i,
            time_slot: aHrStr + aMinStr
        });
    }
    return data;
}

/* function getColumns(data) {
    const columns = [];
    const sample = data[0];
    Object.keys(sample).forEach((key) => {
        if (key !== '_id') {
            columns.push({
                accessor: key,
                Header: "Time Slot",
            })
        }
    })
    return columns;
} */

let state = {
    selected: {0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true, 10: true, 11: true, 12: true, 13: true, 14: true, 15: true, 16: true, 17: true, 18: true, 19: true, 20: true, 21: true, 22: true, 23: true, 24: true, 25: true, 26: true, 27: true, 28: true, 29: true, 30: true, 31: true, 32: true, 33: true, 34: true, 35: true, 36: true, 37: true, 38: true, 39: true, 40: true, 41: true, 42: true, 43: true, 44: true, 45: true, 46: true, 47: true, 48: true, 49: true, 50: true, 51: true, 52: true, 53: true, 54: true, 55: true, 56: true, 57: true, 58: true, 59: true, 60: true, 61: true, 62: true, 63: true, 64: true, 65: true, 66: true, 67: true, 68: true, 69: true, 70: true, 71: true, 72: true, 73: true, 74: true, 75: true, 76: true, 77: true, 78: true, 79: true, 80: true, 81: true, 82: true, 83: true, 84: true, 85: true, 86: true, 87: true, 88: true, 89: true, 90: true, 91: true, 92: true, 93: true, 94: true, 95: true}, 
    selectAll: 1, 
    data: getData(),
};

class TimeSlotTable extends Component {
    /* render() {
        let aTimeSlots;
        if (this.props.timeSlots) {
            aTimeSlots = this.props.timeSlots.map(timeSlot => {
                return (
                    <TimeSlot timeSlot={timeSlot} />
                );
            });
        }
        return (
            <table id="time_slot_tb" style={{ border: '0px solid transparent', font: '14px'}}>
                <tbody style={{ backgroundColor: 'transparent', width: '100%' }}>
                    {aTimeSlots}
                </tbody>
            </table>
        );
    } */
    constructor() {
        super();
        // const data = getData();
        // const columns = getColumns(data);
        this.state = state;
        this.toggleRow = this.toggleRow.bind(this);
    }

    /* componentWillMount(){
        this.setState({
            selected: state.selected,
            selectAll: state.selectAll,
            data: state.data
        });
    } 

    componentDidMount() {
        this.toggleSelectAll();
    } */

    componentWillUnmount() {
        // Remember state for the next mount
        state = this.state;
    }

    toggleRow(id) {
        const newSelected = Object.assign({}, this.state.selected);
        newSelected[id] = !this.state.selected[id];
        this.setState({
            selected: newSelected,
            selectAll: 2
        });
        this.props.updateSelectedTimeSlots(newSelected);
        this.props.updateSelectAllTimeSlots(2);
    }

    toggleSelectAll() {
        let newSelected = {};
        if (this.state.selectAll === 0) {
            this.state.data.forEach(x => {
                newSelected[x._id] = true;
            });
        }
        this.setState({
            selected: newSelected,
            selectAll: this.state.selectAll === 0 ? 1 : 0
        });
        this.props.updateSelectedTimeSlots(newSelected);
        this.props.updateSelectAllTimeSlots(this.state.selectAll === 0 ? 1 : 0);
    }

    render() {
        const columns = [{
            Header: "Time Slots",
            columns: [
                {
                    id: "checkbox",
                    accessor: "",
                    Cell: ({ original }) => {
                        return (
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={this.state.selected[original._id] === true}
                                onChange={() => this.toggleRow(original._id)}
                            />
                        );
                    },
                    Header: x => {
                        return (
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={this.state.selectAll === 1}
                                ref={input => {
                                    if (input) {
                                        input.indeterminate = this.state.selectAll === 2;
                                    }
                                }}
                                onChange={() => this.toggleSelectAll()}
                            />
                        );
                    },
                    sortable: false,
                    width: 45
                },
                {
                    Header: "Time Slot",
                    accessor: "time_slot"
                }
            ]
        }]; 
        return (
            <ReactTable
                data={this.state.data}
                columns={columns}
                style={{
                    height: "380px",
                    width: "230px"
                }}
                defaultPageSize={96}
                showPagination={false}
                className="-striped -highlight"
            />
        );
    }
}

export default TimeSlotTable;



// WEBPACK FOOTER //
// ./src/Componets/TimeSlotsTable.js